<!-- 粉丝打卡 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <div>
            <jd-title label="参与设置" type="bold"></jd-title>
            <el-form-item label="粉丝打卡模式：" required>
              <el-radio-group
                v-model="ruleForm.checkInMode"
                @change="changeCheckInMode"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">集体打卡模式</el-radio>
                <el-radio :label="1">个人打卡模式</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 集体打卡模式 -->
            <div v-if="ruleForm.checkInMode == 0">
              <!-- 目标报名人数 -->
              <el-form-item label="目标报名人数：" required>
                <el-input
                  v-model="ruleForm.tagApplyNum"
                  placeholder="请输入目标报名人数"
                  @input="
                    ruleForm.tagApplyNum = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999
                    )
                  "
                  style="width: 200px"
                  :disabled="backgroundOpacity || activityData.isStart"
                />
                达到指定报名人数才可解锁成功
              </el-form-item>

              <!-- 完成任务报名 -->
              <el-form-item label="完成任务报告：" required>
                <div class="flexc">
                  <jd-button
                    type="blue"
                    :disabled="
                      backgroundOpacity || teamMemberTaskList.length >= 5 || activityData.isStart
                    "
                    @click="addMemberTask"
                    >+添加任务（{{ teamMemberTaskList.length }}/5）</jd-button
                  >
                  <jd-tip class="ml8" style="width: fit-content">
                    {{ ruleForm.checkInMode === 0 ? '*完成全部任务即可报名参与' : '*完成全部任务即可打卡成功，可获取明星海报等奖励' }}  
                  </jd-tip>
                </div>
                <jd-table
                  v-if="teamMemberTaskList.length > 0"
                  :tableData="teamMemberTaskList"
                >
                  <el-table-column label="序号" width="80px">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="任务类型">
                    <template slot-scope="scope">
                      <span>{{ getTaskType(taskTypeOptions, scope.row) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="任务条件" prop="condition">
                    <template slot-scope="scope">
                      <span>{{ getCondition(scope.row) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <jd-button
                        type="blueText"
                        :disabled="backgroundOpacity || activityData.isStart"
                        @click="
                          editMemberTask(scope.row, scope.$index, -1, true)
                        "
                        >修改</jd-button
                      >
                      <jd-button
                        type="blueText"
                        :disabled="(backgroundOpacity || activityData.isStart) && teamMemberTaskList.length <= 1"
                        @click="deleMemberTask(scope.$index)"
                        >删除</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="scope.$index != 0"
                        :disabled="backgroundOpacity"
                        @click="upTask(teamMemberTaskList, scope.$index)"
                        >上移</jd-button
                      >
                      <jd-button
                        type="blueText"
                        @click="downTask(teamMemberTaskList, scope.$index)"
                        :disabled="backgroundOpacity"
                        v-if="scope.$index != teamMemberTaskList.length - 1"
                        >下移</jd-button
                      >
                    </template>
                  </el-table-column>
                </jd-table>
              </el-form-item>

              <!-- 报名截止时间 -->
              <el-form-item label="报名截止时间：" required>
                <el-date-picker
                  v-model="ruleForm.applyEndTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  placeholder="请选择报名截止时间"
                  :picker-options="pickerOptionsValue2"
                  :disabled="backgroundOpacity"
                ></el-date-picker>
                *截止时间前达成报名人数即可解锁成功，否则解锁失败
              </el-form-item>

              <!-- 解锁奖励 -->
              <el-form-item label="解锁奖励：" required>
                <div class="flexc1">
                  <span
                    style="
                      color: #f89f39;
                      margin-left: -2px;
                      margin-bottom: 10px;
                    "
                    >“集体打卡”模式仅支持解锁线下大屏等奖励，非直接赠送给参与用户的奖品，适用于积累报名人数，给代言人点亮线下大屏等应援内容场景；</span
                  >
                  <div class="buttonGroup">
                    <!-- 大屏封面图 -->
                    <el-form-item
                      label="大屏封面图："
                      label-width="110px"
                      required
                    >
                      <div class="buttonGroup">
                        <el-upload
                          class="upload"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          accept=".jpg,.jpeg,.png,.gif"
                          :before-upload="beforeUploadLimits"
                          :on-success="
                            (res) => handleUploads(res, 'screenCoverImage')
                          "
                        >
                          <jd-button
                            type="blue"
                            label="自定义上传"
                            :disabled="backgroundOpacity"
                          ></jd-button> </el-upload
                        >&nbsp;
                        <span class="color-style">尺寸不限，按需上传即可</span>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>

              <!-- 惊喜奖品设置 -->
              <el-form-item label="惊喜奖品设置：" required>
                <el-checkbox
                  v-model="ruleForm.isSurprisePrize"
                  :true-label="1"
                  :false-label="0"
                  :disabled="activityData.isStart || backgroundOpacity"
                  >开启惊喜奖品</el-checkbox
                >
                <span style="color: #f89f39"
                  >（开启则表示达成报名人数目标后，随机抽取X名幸运儿获得幸运礼品；如不开启则仅解锁目标，用户不会获得奖品）</span
                >
              </el-form-item>
              <el-form-item
                label=""
                required
                v-if="ruleForm.isSurprisePrize == 1"
              >
                <div style="width: 1300px">
                  <jd-table :tableData="tableData">
                    <el-table-column label="排序" width="50">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="奖品类型">
                      <template slot-scope="scope">
                        <span>{{ getPrizeTypeName(scope.row.prizeType) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="值"
                      width="100"
                      prop="price"
                    ></el-table-column>
                    <el-table-column label="奖品名称（12字内）" width="270">
                      <template slot="header">
                        <span style="color: red">*</span>奖品名称（12字内）
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.title"
                          maxlength="12"
                          show-word-limit
                          style="width: 230px"
                          placeholder="请输入"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="奖品数量" width="150">
                      <template slot="header">
                        <span style="color: red">*</span>奖品数量
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          v-model.number="scope.row.totalAmount"
                          @input.native="
                            (e) =>
                              (scope.row.totalAmount = checkputn(e, scope.row))
                          "
                          placeholder="请输入"
                          @input="
                            (scope.row.totalAmount = getNumberData(
                              1,
                              $event,
                              0,
                              1,
                              999999
                            )),
                              prizeNum(scope.row)
                          "
                          @blur="beAdd(scope.row)"
                          :disabled="
                            (activityData.isStart && !scope.row.minNum) ||
                            activityData.isStart ||
                            backgroundOpacity
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="图片" width="150">
                      <template slot-scope="scope">
                        <img
                          v-if="scope.row.logo"
                          :src="scope.row.logo"
                          style="width: 56px; height: 56px"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="剩余库存"
                      width="180"
                      v-if="activityData.isStart"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.remanentAmount"
                          style="width: 80px"
                          disabled
                        ></el-input>
                        份
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      fixed="right"
                      min-width="120px"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <jd-button
                          type="blueText"
                          :disabled="backgroundOpacity || activityData.isStart"
                          @click="centerVis(scope, 0)"
                          >选择奖品</jd-button
                        >
                        <!-- <jd-button 
                               v-if="scope.row.logo"
                                :disabled="
                                 backgroundOpacity || activityData.isStart
                                "
                                type="blueText"
                                @click="onDeleteSetting(scope.$index, scope.row)">删除</jd-button>  -->
                        <jd-button
                          type="blueText"
                          v-if="activityData.isStart && !backgroundOpacity"
                          @click="addStock(scope, 0)"
                          >增加库存</jd-button
                        >
                        <!-- &nbsp;&nbsp; -->
                        <!-- <el-upload 
                                v-if="activityData.isStart && !backgroundOpacity"
                              class="upload" 
                              action="/jd-hd-web/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUploadWin" 
                              :on-success="(file) => {
                                   return handleUploadWin(file, scope);
                                }
                              ">
                             <jd-button  type="blueText" >
                                上传图片
                             </jd-button>
                           </el-upload> -->
                      </template>
                    </el-table-column>
                  </jd-table>
                </div>
              </el-form-item>
            </div>

            <!-- 个人打卡模式 -->
            <div v-if="ruleForm.checkInMode == 1">
              <!-- 完成任务报名 -->
              <el-form-item label="完成任务报告：" required>
                <div class="flexc">
                  <jd-button
                    type="blue"
                    :disabled="
                      backgroundOpacity || teamMemberTaskList.length >= 5 || activityData.isStart
                    "
                    @click="addMemberTask"
                    >+添加任务（{{ teamMemberTaskList.length }}/5）</jd-button
                  >
                  <jd-tip class="ml8" style="width: fit-content">
                    *完成全部任务即可打卡成功，可获取明星海报等奖励
                  </jd-tip>
                </div>
                <jd-table
                  v-if="teamMemberTaskList.length > 0"
                  :tableData="teamMemberTaskList"
                >
                  <el-table-column label="序号" width="80px">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="任务类型">
                    <template slot-scope="scope">
                      <span>{{ getTaskType(taskTypeOptions, scope.row) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="任务条件" prop="condition">
                    <template slot-scope="scope">
                      <span>{{ getCondition(scope.row) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <jd-button
                        type="blueText"
                        :disabled="backgroundOpacity || activityData.isStart"
                        @click="
                          editMemberTask(scope.row, scope.$index, -1, true)
                        "
                        >修改</jd-button
                      >
                      <jd-button
                        type="blueText"
                        :disabled="(backgroundOpacity || activityData.isStart) && teamMemberTaskList.length <= 1"
                        @click="deleMemberTask(scope.$index)"
                        >删除</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="scope.$index != 0"
                        :disabled="backgroundOpacity"
                        @click="upTask(teamMemberTaskList, scope.$index)"
                        >上移</jd-button
                      >
                      <jd-button
                        type="blueText"
                        @click="downTask(teamMemberTaskList, scope.$index)"
                        :disabled="backgroundOpacity"
                        v-if="scope.$index != teamMemberTaskList.length - 1"
                        >下移</jd-button
                      >
                    </template>
                  </el-table-column>
                </jd-table>
              </el-form-item>

              <el-form-item label="解锁奖励：" required>
                <div
                  v-if="ruleForm.checkInMode == 1"
                  style="
                    background: rgb(244, 246, 250);
                    padding: 16px 16px 16px 16px;
                    width: fit-content;
                  "
                >
                  <jd-tip color="text" style="margin-bottom: 10px">
                    "个人打卡"模式属于个人完成任务参与获得奖励的形式，无需累积报名人数，每人参与成功都可获得相应奖励，适合入会获取明星海报等场景
                  </jd-tip>
                  <el-form-item label="手机壁纸：" label-width="98px">
                    <div style="display: flex; align-items: center">
                      <el-upload
                        action="/jd-hd-web/image/uploadWithCompress"
                        ref="upload"
                        :on-success="
                          (file) => {
                            return handleChange(file, 'phone');
                          }
                        "
                        :show-file-list="false"
                        accept=".jpg,.jpeg,.png,.gif"
                        :before-upload="beforeUploadLimits"
                      >
                        <jd-button type="blue" style="margin-right: 16px"
                          >上传图片</jd-button
                        >
                      </el-upload>
                      <div style="color: #999999">
                        尺寸建议：4500px*9688px；支持格式：jpg，png，gif
                      </div>
                    </div>
                    <div style="display: flex">
                      <draggable
                        v-model="ruleForm.wallpaperList"
                        chosen-class="chosen"
                        :scroll="true"
                        animation="150"
                        force-fallback="true"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        style="padding-top: 10px"
                      >
                        <transition-group type="transition">
                          <div
                            v-for="(item, index) in ruleForm.wallpaperList"
                            :key="item.compressedImageUrl"
                            style="display: inline-block; position: relative"
                            class="upload-item"
                          >
                            <el-image
                              :src="item.compressedImageUrl"
                              class="phone-img"
                              style="display: inline-block"
                              fit="cover"
                              :lazy="true"
                            />&nbsp;
                            <div class="delectPosible phone-img">
                              <span class="delectSort">拖动排序</span>
                              <img
                                :src="globalCdn + '/thdImg/pages/delet.svg'"
                                @click.stop="delec(index, 'wallpaperList')"
                                class="delectIcom"
                              />
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </el-form-item>
                  <el-form-item label="电脑壁纸：" label-width="98px" >
                    <div style="display: flex; align-items: center">
                      <el-upload
                        action="/jd-hd-web/image/uploadWithCompress"
                        ref="upload"
                        :on-success="
                          (file) => {
                            return handleChange(file, 'computer');
                          }
                        "
                        :show-file-list="false"
                        accept=".jpg,.jpeg,.png,.gif"
                        :before-upload="beforeUploadLimits"
                      >
                        <jd-button type="blue" style="margin-right: 16px"
                          >上传图片</jd-button
                        >
                      </el-upload>
                      <div style="color: #999999">
                        尺寸建议：5567px*3125px；支持格式：jpg，png，gif
                      </div>
                    </div>
                    <div style="display: flex">
                      <draggable
                        v-model="ruleForm.pcWallpaperList"
                        chosen-class="chosen"
                        :scroll="true"
                        animation="150"
                        force-fallback="true"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        style="padding-top: 10px"
                      >
                        <transition-group type="transition">
                          <div
                            v-for="(item, index) in ruleForm.pcWallpaperList"
                            :key="item.compressedImageUrl"
                            style="display: inline-block; position: relative"
                            class="upload-item"
                          >
                            <el-image
                              :src="item.compressedImageUrl"
                              class="computer-img"
                              style="display: inline-block"
                              fit="cover"
                              :lazy="true"
                            />&nbsp;
                            <div class="delectPosible computer-img">
                              <span class="delectSort">拖动排序</span>
                              <img
                                :src="globalCdn + '/thdImg/pages/delet.svg'"
                                @click.stop="delec(index, 'pcWallpaperList')"
                                class="delectIcom"
                              />
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </el-form-item>
                  <el-form-item label="ipad壁纸：" label-width="98px" >
                    <div style="display: flex; align-items: center">
                      <el-upload
                        action="/jd-hd-web/image/uploadWithCompress"
                        ref="upload"
                        :on-success="
                          (file) => {
                            return handleChange(file, 'ipad');
                          }
                        "
                        :show-file-list="false"
                        accept=".jpg,.jpeg,.png,.gif"
                        :before-upload="beforeUploadLimits"
                      >
                        <jd-button type="blue" style="margin-right: 16px"
                          >上传图片</jd-button
                        >
                      </el-upload>
                      <div style="color: #999999">
                        尺寸建议：4000px*2795px；支持格式：jpg，png，gif
                      </div>
                    </div>
                    <div style="display: flex">
                      <draggable
                        v-model="ruleForm.ipadWallpaperList"
                        chosen-class="chosen"
                        :scroll="true"
                        animation="150"
                        force-fallback="true"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        style="padding-top: 10px"
                      >
                        <transition-group type="transition">
                          <div
                            v-for="(item, index) in ruleForm.ipadWallpaperList"
                            :key="item.compressedImageUrl"
                            style="display: inline-block; position: relative"
                            class="upload-item"
                          >
                            <el-image
                              :src="item.compressedImageUrl"
                              class="ipad-img"
                              style="display: inline-block"
                              fit="cover"
                              :lazy="true"
                            />&nbsp;
                            <div class="delectPosible ipad-img">
                              <span class="delectSort">拖动排序</span>
                              <img
                                :src="globalCdn + '/thdImg/pages/delet.svg'"
                                @click.stop="delec(index, 'ipadWallpaperList')"
                                class="delectIcom"
                              />
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
            </div>
            <!-- 预览对话框 -->
            <el-dialog
              :visible.sync="dialogVisible"
              :show-close="false"
              class="preview-dialog"
            >
              <template #title></template>
              <img
                class="img"
                width="100%"
                :src="dialogImageUrl"
                alt="预览图片"
              />
            </el-dialog>
          </div>
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="ruleForm.checkInMode != 1"
            :isNeedShowTemplate="ruleForm.checkInMode != 1"
            :giftList="giftList"
            themeTitle="主题"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            :widthNumber="750"
            :heightNumber="2004"
            previewKey="url"
            templatekey="imageUrl"
            :isShowDesignNumber="false"
            :descLimit="25"
            :downloadTemplateUrl="baseUrl + 'fsdk-template.psd'"
            :designSpecificationsUrl="baseUrl + 'fsdk_rule.png'"
            v-model="customerPaperwork"
            :isCustomPreview="true"
          >
            <template #customPreview>
              <previewPageDialog
                :ruleForm="{
                  ...ruleForm,
                  tableData,
                }"
                :baseUrl="baseUrl"
                :backgroundImage="ruleForm.backgroundImage"
                :cusTemplateJSON="ruleDTO.cusTemplateJSON"
              ></previewPageDialog>
            </template>
            <template #otherSet>
              <el-form-item label="按钮设置:" required>
                <div
                  style="
                    background: #f4f6fa;
                    padding: 20px 20px 20px 0;
                    width: fit-content;
                  "
                >
                  <el-form-item label="按钮背景图：" label-width="120px">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="handleUpload"
                      >
                        <div class="btn-bg" v-if="customerPaperwork.btnBgUrl">
                          <img
                            :src="customerPaperwork.btnBgUrl"
                            style="width: 100%; height: auto"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueText"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="resetButtonBackground('1')"
                        style="margin: 0 16px 0 16px"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="color-style">尺寸建议：580*98px</span>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="按钮文字色："
                    label-width="120px"
                    style="margin-bottom: 0"
                  >
                    <div class="buttonGroup">
                      <el-color-picker
                        v-model="customerPaperwork.btnWordColor"
                        size="small"
                      ></el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin: 0 12px 0 16px"
                        @click="resetButtonBackground('2')"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <!-- <el-form-item
            label="进度条设置："
            required
            v-if="ruleForm.checkInMode == 0"
          >
            <div
              style="
                background: #f4f6fa;
                padding: 20px 20px 20px 0;
                width: 415px;
              "
            >
              <el-form-item label="背景：" label-width="70px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.progressBarBgColor"
                    :disabled="true"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    style="margin-left: 16px"
                    type="blueText"
                    :disabled="true"
                    @click="resetButtonBackground('3')"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="进度：" label-width="70px">
                <div class="buttonGroup">
                  <el-color-picker
                    v-model="customerPaperwork.progressBarColor"
                    :disabled="true"
                    size="small"
                  ></el-color-picker>
                  <jd-button
                    style="margin-left: 16px"
                    type="blueText"
                    :disabled="true"
                    @click="resetButtonBackground('4')"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
            </div>
          </el-form-item> -->
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :limitNum="limitNum"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :needIsForceRemind="true"
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity" 
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 打卡任务-->
    <addTaskDialog
      v-if="taskDialog"
      :taskDataLists="taskDataList"
      :taskDialog="taskDialog"
      :currentIndex="currentIndex"
      :isTaskEdit="isTaskEdit"
      :taskTypeOptions="taskTypeOptions"
      :taskData="taskForm"
      :isShowHis="true"
      @getTaskDataList="getTaskDataList"
      @closeTask="taskDialog = false"
      :ruleForm="ruleForm"
      :venderType="venderType"
    ></addTaskDialog>

    <!-- 打卡任务 -->
    <addTaskDialog
      v-if="memberTaskDialog"
      :taskDataLists="teamMemberTaskList"
      :taskDialog="memberTaskDialog"
      :currentIndex="memberCurrentIndex"
      :isTaskEdit="isMemberTaskEdit"
      :taskTypeOptions="taskTypeOptions"
      :taskData="memberTaskForm"
      :isShowHis="true"
      @getTaskDataList="getMemberTaskDataList"
      @closeTask="memberTaskDialog = false"
      :ruleForm="ruleForm"
      :venderType="venderType"
    ></addTaskDialog>
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import selectProduct from "./select_product_componentization.vue";
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon, fansCard } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import addTaskDialog from "./components/unlock_task_dialog.vue";
import draggable from "vuedraggable";
import previewPageDialog from "./components/previewPageFansCard.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
const baseImgUrl = "https://cdn-image.yucrm.cn/images/fansCheckIn/";
export default {
  components: {
    SelectGoods,
    selectProduct,
    draggable,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    addTaskDialog,
    previewPageDialog,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customerPaperwork: {
      handler(val) {
        if(val.title){
          this.ruleForm.theme = val.title;
        }
        if(val.desc){
          this.ruleForm.description = val.desc;
        }
        if (val.titleColor) {
          this.ruleForm.wordColor = val.titleColor;
        }
        if (val.btnWordColor) {
          this.ruleForm.buttonWordColor = val.btnWordColor;
        }
        if (val.progressBarColor) {
          this.ruleForm.progressColor = val.progressBarColor;
        }
        if (val.progressBarBgColor) {
          this.ruleForm.progressBgColor = val.progressBarBgColor;
        }
      },
      deep: true, // 监听对象内部属性变化
    },
  },
  data() {
    return {
      pickerOptionsValue2: {
        disabledDate: (time) => {
          if(!this.activityData.isCopy){
            if (!this.activityStartTime || this.activityStartTime.length == 0) return true ;
            const startStamp =
             new Date(this.activityStartTime).getTime() - 24 * 60 * 60 * 1000;
             const endStamp = new Date(this.activityEndTime).getTime();
             return time.getTime() < startStamp || time.getTime() > endStamp;
          }else{
           if (!this.activityStartTime || this.activityStartTime.length == 0) return false ;
           const startStamp =
           new Date(this.activityStartTime).getTime() - 24 * 60 * 60 * 1000;
           const endStamp = new Date(this.activityEndTime).getTime();
           return time.getTime() < startStamp || time.getTime() > endStamp;
          }
      
        },
      },
      isForceRemind: false,
      isKeyActivity: 0,
      placementPosition: [],
      itemArr: [],
      saveLoading: false,
      // 团长奖品设置表单
      commanderForm: {
        commanderPrizeType: 0,
        openTeamType: 0,
        inviteTeamNum: "",
        isSurprisePrize: "0",
      },
      baseUrl: "https://cdn-image.yucrm.cn/images/fansCheckIn/",
      globalCdn: "https://cdn-image.yucrm.cn/images/dyAssets",
      memberJoinSetting: {
        memberJoinType: 0,
        allowLevel: ["-1"],
        isCheckOpenCardTime: false,
        openCardStartTime: "",
        openCardEndTime: "",
        filterInviteRuleType: 0,
        openTeamType: 0,
      },
      tableIndex: 2,
      selectPrizeType: 0, // 0:统一奖品 1:团员奖品
      showSelectProduct: false,
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      stepPrizeIndex: -1,
      toAddItem: null,
      isShowAddNum: false,
      prizeIndex: "",
      // Sortable.js实例
      sortableInstance: null,
      // 奖品列表
      tableData: [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      teamMemberTable: [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      taskForm: {}, //团长任务编辑时接收
      memberTaskForm: {}, //团员任务编辑时接收
      taskTypeOptions: [
        {
          label: "购买商品",
          value: 17,
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
        },
        {
          label: "关注店铺",
          value: 6,
          taskCondition: "成功关注店铺",
        },
        {
          label: "预约商品",
          value: 12,
        },
        {
          label: "浏览商品",
          value: 13,
          activityType: 1,
        },
        {
          label: "浏览店铺",
          value: 2,
          taskCondition: "成功浏览店铺1次",
          activityType: 1,
        },
      ],
      currentIndex: 0, //团长当前选中的任务
      memberCurrentIndex: 0, //团员当前选中的任务
      taskDataList: [], //团长统一奖品任务
      prizeSettingListStep: [
        // 团长阶梯奖品务
        {
          openTeamType: 0, // 开团要求 0 符合参与对象可直接开团 1 符合参与对象，并且需要完成任务后方可开团
          inviteTeamNum: null, // 邀请人数
          table: [
            {
              assetsId: null, // 资产项id(计划id优惠卷id商品id)
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
          taskList: [],
        },
        {
          openTeamType: 0, // 开团要求 0 符合参与对象可直接开团 1 符合参与对象，并且需要完成任务后方可开团
          inviteTeamNum: null, // 邀请人数
          table: [
            {
              assetsId: null, // 资产项id(计划id优惠卷id商品id)
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
          taskList: [],
        },
      ],
      teamMemberTaskList: [], //团员任务
      // 任务设置
      isTaskEdit: false,
      taskDialog: false,
      isMemberTaskEdit: false,
      memberTaskDialog: false,
      isStepTask: false, //判断是否为阶梯
      // --end
      loading: false,
      templateObj: {},
      currrentRgb: "#ffffff",
      customerPaperwork: { //京东按钮设置和进度条设置属性都放在这
        title: "线下大屏解锁计划",
        desc: "完成任务为爱豆点亮线下大屏",
        titleColor: "#242424",
        btnWordColor: "#ffffff", //按钮字体颜色
        btnBgUrl: "",
        hideStock: 0, // 0 显示（C端活动页奖品显示剩余库存） 1 不显示
        unlockRewardUrl: "", //解锁奖励图片
        progressBarBgColor: "#c4cad2", //进度条背景颜色
        progressBarColor: "#FFF4E4",
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        theme: "线下大屏解锁计划", //活动主题
        description: "完成任务为爱豆点亮线下大屏", //活动说明
        wordColor: "#1A1A1A", //文字颜色（初始值与customerPaperwork.titleColor一致）
        backgroundImage: baseImgUrl + "bg_img.png", //背景图
        buttonBackgroundColor: baseImgUrl + "buttonBg.png", //按钮设置背景图
        buttonWordColor: "#FFFFFF", //按钮文字颜色
        progressBgColor: "#c4cad2",
        progressColor: "#FFF4E4",
        screenCoverImage: "", // 封面图
        checkInMode: 0, // 打卡模式
        wallpaperList: [],
        ipadWallpaperList: [],
        pcWallpaperList: [],
        tagApplyNum: "", //目标报名人数
        applyEndTime: "", // 报名结束时间
        isSurprisePrize: 0, // 是否开启惊喜奖品
        isValidBlackList: 0,
      },
      ruleDTO: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
      },
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      isDraft: false,
      // 手机壁纸
      mobileWallpapers: [
        {
          url: "https://cdn-image.yucrm.cn/d47f11bc5c694308822da247519927d1.png",
        },
        {
          url: "https://cdn-image.yucrm.cn/d47f11bc5c694308822da247519927d1.png",
        },
      ],
      mobileFileList: [],
      // 电脑壁纸
      computerWallpapers: [],
      computerFileList: [],
      // iPad壁纸
      ipadWallpapers: [],
      ipadFileList: [],
      // 图片上传相关
      dialogVisible: false,
      dialogImageUrl: "",
      // Sortable.js实例管理
      sortableInstances: {},
    };
  },
  computed: {
    // 获取任务类型
    getTaskType() {
      return (arr, row) => {
        const obj = arr.find((item) => item.value == row.taskType);
        return obj.label;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const {
          taskType,
          taskCondition,
          itemStartCount,
          orderStartPayment,
          orderType,
        } = item;
        let str = taskCondition;
        if (taskType == 3 || taskType == 13) {
          str = `成功浏览${taskCondition}件商品`;
        } else if (taskType == 12) {
          str = `成功预约${taskCondition}件商品`;
        } else if (taskType == 17) {
          str = `在规定时间范围内，购买商品大于等于：${
            itemStartCount ? `${itemStartCount}件` : ""
          }${
            orderStartPayment ? `${orderStartPayment}元` : ""
          }，且订单状态为：${orderType == 1 ? "已完成" : "已付款"}`;
        }
        return str;
      };
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(65);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "粉丝打卡", "互动管理", "互动活动");
    this.initSortable();
  },
  methods: {
    // 上传前校验
    beforeUploadWin(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 208;
        let height = 208;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message.info("奖品展示图片尺寸不符合要求,请重新上传");
          return Promise.reject();
        }
      );

      // 校验尺寸和类型
      const isLt3M = file.size < 300 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type);

      if (!isLt3M) {
        this.$message.info("奖品展示图片大小不符合要求,请重新上传");
      }
      if (!isType) {
        this.$message.info("奖品展示图片格式不符合要求,请重新上传");
      }

      return isLt3M && isType && isSize;
    },
    //图片更换
    handleUploadWin(file, scope) {
      if (file.code != 1) {
        this.$message.error(file.messaga || "上传失败");
        return;
      }
      // 更新图片URL到对应的奖品设置中
      if (this.uploadSize) {
        this.$set(scope.row, "logo", file.data);
      }
    },
    //打卡模式
    changeCheckInMode() {
      if (this.ruleForm.checkInMode == 1) {
        this.customerPaperwork.title = "粉丝打卡";
        this.customerPaperwork.desc = "完成任务下载明星海报";
      } else if (this.ruleForm.checkInMode == 0) {
        this.customerPaperwork.title = "线下大屏解锁计划";
        this.customerPaperwork.desc = "完成任务为爱豆点亮线下大屏";
      }
    },
    //上传图片
    handleChange(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == "phone") {
          this.ruleForm.wallpaperList.push({
            compressedImageUrl: res.data.compressedImageUrl,
            fileUrl: res.data.fileUrl,
            type: "phone",
          });
        } else if (type == "ipad") {
          this.ruleForm.ipadWallpaperList.push({
            compressedImageUrl: res.data.compressedImageUrl,
            fileUrl: res.data.fileUrl,
            type: "ipad",
          });
        } else if (type == "computer") {
          this.ruleForm.pcWallpaperList.push({
            compressedImageUrl: res.data.compressedImageUrl,
            fileUrl: res.data.fileUrl,
            type: "computer",
          });
        }
      }
    },
    //个人打卡模式图片删除
    delec(index, list) {
      this.ruleForm[list].splice(index, 1);
    },
    //集体解锁奖励
    async beforeUploads(file, field) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".jpeg", ".gif"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },
    // 上传成功
    handleUploads(res, field) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        let url = res.data;
        if (field == "screenCoverImage") {
          this.ruleForm.screenCoverImage = url;
        }
        this.$message.success("图片上传成功~");
      }
    },
    // 按钮背景图上传图片
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.customerPaperwork.btnBgUrl = res.data;
        this.ruleForm.buttonBackgroundColor = res.data;
        this.$message.success("按钮背景图上传成功");
      }
    },
    clearPrize() {
      this.teamMemberTable = [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ];
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // 解锁奖励图片上传
    handleUnlockRewardUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message || res.msg);
      } else {
        this.customerPaperwork.unlockRewardUrl = res.data;
        this.$message.success("解锁奖励图片上传成功");
      }
    },
    clearMembershipTime() {
      this.memberJoinSetting.openCardStartTime = "";
      this.memberJoinSetting.openCardEndTime = "";
    },
    checkLevelchange(val) {
      if (
        val[val.length - 1] == "-1" ||
        this.memberJoinSetting.allowLevel.length == 0
      ) {
        this.memberJoinSetting.allowLevel = ["-1"];
      } else {
        this.memberJoinSetting.allowLevel = val.filter((item) => item != "-1");
      }
    },
    getTheData(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price = Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj,prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }

      if (this.selectPrizeType == 0) {
        // 统一奖品
        this.$set(this.tableData, this.prizeIndex, prizeObj);
      } else if (this.selectPrizeType == 1) {
        // 阶梯奖品
        this.$set(
          this.prizeSettingListStep[this.selectedStep].table,
          this.prizeIndex,
          prizeObj
        );
      } else if (this.selectPrizeType == 2) {
        // 团员奖品
        this.$set(this.teamMemberTable, this.prizeIndex, prizeObj);
      }
      this.showSelectProduct = false;
    },
    //选择奖品弹窗
    centerVis(scope, type, stepIndex) {
      // type: 0统一奖品 1:阶梯奖品 2:团员奖品
      this.selectPrizeType = type;
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      if (stepIndex >= 0) {
        this.selectedStep = stepIndex;
      }
      this.prizeIndex = scope.$index;
      this.echoDate = scope.row;
      this.showSelectProduct = true;
      this.itemArr =
        type == 0
          ? this.tableData
          : type == 1
          ? this.prizeSettingListStep[stepIndex].table
          : this.teamMemberTable;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    confirmAdd(num) {
      if (this.stepPrizeIndex >= 0 && this.selectPrizeType == 1) {
        this.$set(
          this.prizeSettingListStep[this.stepPrizeIndex].table[this.prizeIndex],
          "totalAmount",
          Number(num)
        );
      } else {
        const table = {
          0: this.tableData,
          2: this.teamMemberTable,
        };
        this.$set(
          table[this.selectPrizeType][this.prizeIndex],
          "totalAmount",
          Number(num)
        );
      }
      this.isShowAddNum = false;
    },
    // 添加库存
    addStock(scope, type, stepIndex) {
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.selectPrizeType = type;
      if (stepIndex >= 0) {
        this.stepPrizeIndex = stepIndex;
      }
      this.isShowAddNum = true;
      this.prizeIndex = scope.$index;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },
    // 修改
    editMemberTask(row, $index) {
      this.memberCurrentIndex = $index;
      const copyRow = JSON.parse(JSON.stringify(row));
      this.isMemberTaskEdit = true;
      this.memberTaskForm = copyRow;
      this.memberTaskDialog = true;
    },
    // 上移
    upTask(arr, $index) {
      arr[$index] = arr.splice($index - 1, 1, arr[$index])[0];
    },
    // 下移
    downTask(arr, $index, stepIndex) {
      if (stepIndex >= 0) {
        arr[$index] = arr.splice($index + 1, 1, arr[$index])[0];
      } else {
        arr[$index] = arr.splice($index + 1, 1, arr[$index])[0];
      }
    },
    // 删除任务
    deleteTask($index, stepIndex) {
      if (stepIndex >= 0) {
        this.prizeSettingListStep[$index].taskList.splice($index, 1);
      } else {
        this.taskDataList.splice($index, 1);
      }
    },
    deleMemberTask($index) {
      this.teamMemberTaskList.splice($index, 1);
    },
    getTaskDataList(selectList) {
      this.taskDataList = selectList;
      this.taskDialog = false;
    },
    getMemberTaskDataList(selectList) {
      this.teamMemberTaskList = selectList;
      this.memberTaskDialog = false;
    },
    // 粉丝打卡添加任务
    addMemberTask() {
      this.isMemberTaskEdit = false;
      this.memberTaskDialog = true;
    },
    // 模板设置动态关联属性添加
    selectTemplate(index, id, item) {
      this.ruleForm.backgroundImage = item.imageUrl;
      this.ruleForm.buttonBackgroundColor = item.url2
      this.ruleForm.buttonWordColor = item.rgb
      this.ruleForm.progressBgColor = item.rgb2
      this.ruleForm.progressColor = item.rgb3
      // this.customerPaperwork.progressBarBgColor = item.rgb2
      // this.customerPaperwork.progressBarColor =item.rgb3
      this.customerPaperwork.btnBgUrl =item.url2
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.customerPaperwork.btnWordColor = item.rgb;
      this.currrentRgb = item.rgb;
    },
    // 重置按钮背景和相关颜色
    resetButtonBackground(type) {
      // 使用templateObj作为当前选中的系统模板，而不是从giftList中重新获取
      // templateObj在selectTemplate方法中被设置为当前选中的模板
      if (this.templateObj && Object.keys(this.templateObj).length > 0) {
        switch (type) {
          case '1': // 重置按钮背景
            this.customerPaperwork.btnBgUrl = this.templateObj.url2;
            this.ruleForm.buttonBackgroundColor = this.templateObj.url2;
            break;
          case '2': // 重置按钮文字颜色
            this.customerPaperwork.btnWordColor = this.templateObj.rgb;
            this.ruleForm.buttonWordColor = this.templateObj.rgb;
            break;
          case '3': // 重置进度条背景和颜色
            // this.customerPaperwork.progressBarBgColor = this.templateObj.rgb2; // 使用rgb2作为背景色
            // this.ruleForm.progressColor = this.templateObj.rgb2;
            break;
          case '4': // 重置用户进度条颜色
            // this.customerPaperwork.progressBarColor = this.templateObj.rgb3; // 使用rgb3作为进度条颜色，与selectTemplate方法保持一致
            // this.ruleForm.progressBgColor = this.templateObj.rgb3;
            break;
        }
      } else if (this.giftList && this.giftList.length > 0) {
        // 兼容处理：如果templateObj不存在，则使用giftList的第一个模板作为默认值
        const defaultTemplate = this.giftList[0];
        switch (type) {
          case '1': // 重置按钮背景
            this.customerPaperwork.btnBgUrl = defaultTemplate.url2;
            this.ruleForm.buttonBackgroundColor = defaultTemplate.url2;
            break;
          case '2': // 重置按钮文字颜色
            this.customerPaperwork.btnWordColor = defaultTemplate.rgb;
            this.ruleForm.buttonWordColor = defaultTemplate.rgb;
            break;
          case '3': // 重置进度条背景和颜色
            // this.customerPaperwork.progressBarBgColor = defaultTemplate.rgb2; // 使用rgb2作为背景色
            // this.ruleForm.progressColor = defaultTemplate.rgb2;
            break;
          case '4': // 重置用户进度条颜色
            // this.customerPaperwork.progressBarColor = defaultTemplate.rgb3; // 使用rgb3作为进度条颜色，与selectTemplate方法保持一致
            // this.ruleForm.progressBgColor = defaultTemplate.rgb3;
            break;
        }
      }
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },
    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.customerPaperwork.btnWordColor = this.giftList[0].rgb;
        this.ruleForm.backgroundImage = this.giftList[0].imageUrl;
        this.ruleForm.buttonBackgroundColor = this.giftList[0].url2;
        this.customerPaperwork.btnBgUrl = this.giftList[0].url2
        this.ruleForm.progressBgColor = this.giftList[0].rgb2
        this.ruleForm.progressColor = this.giftList[0].rgb3
        this.customerPaperwork.progressBarBgColor = this.giftList[0].rgb2
        this.customerPaperwork.progressBarColor = this.giftList[0].rgb3
        this.currrentRgb = this.giftList[0].rgb;
        this.templateObj = this.giftList[0];
        //TODO:1.53背景图默认
        this.ruleForm.backgroundImage = this.giftList[0].imageUrl;
      } else if (this.templateId) {
         let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.customerPaperwork.btnWordColor =
          this.customerPaperwork.btnWordColor;
        this.currrentRgb = this.templateObj.rgb;
        this.ruleForm.backgroundImage = this.templateObj.imageUrl;
        this.ruleForm.buttonBackgroundColor = this.customerPaperwork.btnBgUrl ? this.customerPaperwork.btnBgUrl:this.templateObj.url2;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //添加任务规则说明
    getConditionText(item) {
      let type_1 = ["商品", "指定商品", "非排除商品"];
      let str =
        item.taskType == 17
          ? `${item.orderStartTime}~${item.orderEndTime}期间下单付款${
              type_1[item.skuType]
            }${
              item.skuType == 2
                ? "的订单不计算入内,仅统计购买其他商品的商品件数及金额，"
                : ""
            }${
              item.itemStartCount
                ? "且商品件数：大于等于" + item.itemStartCount + "件"
                : ""
            }，${
              item.orderStartPayment
                ? "且订单金额：大于等于" + item.orderStartPayment + "元"
                : ""
            }，且订单状态为：${item.orderType == 1 ? "已完成" : "已付款"}`
          : this.getCondition(item);
      return str;
    },
    //生成规则
    generateRule() {
      let 
        text10 = "参与方式：",
        text11 = "",
        text12 = "",
        text13 = "报名条件：需完成以下任务",
        text25 = "",
        text26 = "",
        text27 = "",
        secondText = "\n二、【如何解锁】",
        thirdText = "\n三、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDTO,this.actMember)
      // 新增规则
      const sortArr = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
      //新增规则集卡
      text10 +=
        this.ruleForm.checkInMode == 0
          ? "报名截止时间之前，进入活动完成指定任务后手动报名参与；"
          : "活动有效期内，进入活动完成指定任务后参与；";
      this.teamMemberTaskList.forEach((item, index) => {
        text13 += "\n" + "("+
          sortArr[index] + ")"+
          this.getConditionText(item) +
          "；";
      });
      text11 = `报名截止时间：${this.ruleForm.applyEndTime}；`;
      text12 = `目标报名人数：${this.ruleForm.tagApplyNum}人报名即可解锁成功；`;
      if (this.ruleForm.isSurprisePrize == 1) {
        text25 = `惊喜奖品：解锁成功后，随机抽取 ${this.tableData[0].totalAmount} 位幸运儿，可获得惊喜奖品 ${this.tableData[0].title}${this.tableData[0].prizeType==3 ? ('，单份奖品价值'+this.tableData[0].price+'元') : ''}`;
        text26 =
          "报名解锁截止时间后，需返回活动页查看是否获得惊喜礼品资格，中奖后不代表获得奖品，奖品以实际发放情况为主；";
        text27 =
          "如果是实物奖项，需填写收货地址后进行发货，活动结束后不允许填写地址，请在活动时间内填写地址，否则将视为放弃机会；";
      }
      // 个人打卡不需要该规则
      if (this.ruleForm.checkInMode == 1) {
        text11 = "";
        text12 = "";
        text25 = "";
        text26 = "";
        text27 = "";
      }
      let Arr1 = [
        firstText,
        [secondText, text10,text13,text11,text12,text25,text26,text27],
        [thirdText,precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    // 下一步
    resetForm() {
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品！");
        return;
      }
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }
      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }
      // 报名截止时间不能小于当前时间
        if (
          new Date(this.ruleForm.applyEndTime).getTime() < Date.now() 
        ) {
          this.$message.warning("报名截止时间不能小于当前时间");
          return;
        }

      // 请将奖品填写完整！
      let isFlay = false;
      if (this.ruleForm.isSurprisePrize == 1) {
        this.tableData.forEach((item) => {
          if (!item.prizeType || !item.totalAmount) {
            isFlay = true;
          }
        });

        if (isFlay) {
          this.$message.warning("请将奖品填写完整！");
          return;
        }
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      // 个人模式下，校验至少有一张壁纸
      if (this.ruleForm.checkInMode === 1) {
        const hasMobileWallpaper = this.ruleForm.wallpaperList && this.ruleForm.wallpaperList.length > 0;
        const hasPcWallpaper = this.ruleForm.pcWallpaperList && this.ruleForm.pcWallpaperList.length > 0;
        const hasIpadWallpaper = this.ruleForm.ipadWallpaperList && this.ruleForm.ipadWallpaperList.length > 0;
        
        if (!hasMobileWallpaper && !hasPcWallpaper && !hasIpadWallpaper) {
          this.$message.warning('手机壁纸、电脑壁纸和iPad壁纸中至少需要上传一张壁纸');
          return;
        }
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    // 统一处理任务数据
    handleTaskData(data) {
      const taskObj = {
        ...data,
        type: 0,
      };
      if ([3, 4, 12, 13].includes(data.taskType)) {
        taskObj.itemList = data.itemListForFilter;
        if (data.itemListForFilter && data.itemListForFilter.length) {
          taskObj.skuIds = data.itemListForFilter
            .map((item) => item.skuId)
            .join(",");
        }
        if ([3, 12, 13].includes(data.taskType)) {
          taskObj.viewCartLimit = data.taskCondition;
        } else {
          // 加购商品
          taskObj.addCartLimit = data.taskCondition;
        }
      }
      if (data.taskType == 17) {
        taskObj.itemList = data.selectGoodsFilterArr;
        if (data.selectGoodsFilterArr && data.selectGoodsFilterArr.length) {
          taskObj.skuIds = data.selectGoodsFilterArr
            .map((item) => item.skuId)
            .join(",");
        }
        taskObj.skuIds = []
        taskObj.venderIds = data.venderIds.join(",");
        taskObj.sellerSkuList = data.sellerSkuList.map((row)=>{
          return {
            skuIds: row.skuIds,
            venderId: row.venderId,
          }
        });
        taskObj.itemTotalLimit = data.itemStartCount;
        taskObj.amtLimit = data.orderStartPayment;
        // 指定商品规则提交，老数据无该字段时默认整单计算
        taskObj.statsSkuType = data.statsSkuType || 0;
      }
      return taskObj;
    },
    // 预览图片
    previewImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移除图片
    removeImage(listName, index) {
      this[listName].splice(index, 1);
      // 重新初始化拖动功能
      this.initSortable(listName);
    },
    // 图片上传前校验
    beforeUpload(file) {
      const status = this.imgchecked(file, 580, 98);
      if (!status) {
        return false;
      }
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        this.$message.error("只能上传图片文件");
        return false;
      }
      // const isLt300K = file.size / 1024 <= 300;
      // if (!isLt300K) {
      //   this.$message.error("上传图片大小不能超过 300KB");
      //   return false;
      // }
      // 限制图片格式
      const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!allowedTypes.includes(file.type)) {
        this.$message.error("只能上传 JPG、PNG 或 GIF 格式的图片");
        return false;
      }
      return true;
    },
    beforeUploadLimits(file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        this.$message.error("只能上传图片文件");
        return false;
      }
      // const isLt300K = file.size / 1024 <= 300;
      // if (!isLt300K) {
      //   this.$message.error("上传图片大小不能超过 300KB");
      //   return false;
      // }
      // 限制图片格式
      const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!allowedTypes.includes(file.type)) {
        this.$message.error("只能上传 JPG、PNG 或 GIF 格式的图片");
        return false;
      }
      return true;
    },
    // 图片上传成功处理
    handleSuccess(response, file, fileList, listName) {
      if (response.success) {
        const imageUrl = response.data;
        this[listName].push({ url: imageUrl });
        // 初始化拖动功能
        this.initSortable(listName);
      } else {
        this.$message.error("图片上传失败：" + response.msg);
      }
      // 更新对应的fileList
      this[listName.replace("Wallpapers", "FileList")] = fileList;
    },
    // 图片删除处理
    onRemove(file, fileList, listName) {
      // 找到要删除的图片在对应列表中的索引
      const index = this[listName].findIndex(
        (item) => item.url === file.response.data
      );
      if (index !== -1) {
        this[listName].splice(index, 1);
      }
      // 更新对应的fileList
      this[listName.replace("Wallpapers", "FileList")] = fileList;
    },
    // 删除奖品设置
    onDeleteSetting(index, item) {
      this.tableData = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ];
    },
    // 初始化拖动功能
    initSortable(listName) {
      // 支持初始化单个或所有列表
      const listsToInit = listName
        ? [listName]
        : ["mobileWallpapers", "computerWallpapers", "ipadWallpapers"];
      listsToInit.forEach((name) => {
        const refName = name.replace("Wallpapers", "WallpaperList");
        const el = this.$refs[refName];
        if (!el) return;
        // 销毁现有的Sortable实例
        if (this.sortableInstances[name]) {
          this.sortableInstances[name].destroy();
        }
        // 使用Sortable.js实现拖动排序
        this.sortableInstances[name] = Sortable.create(el, {
          animation: 150,
          onEnd: (evt) => {
            // 更新对应列表的数据顺序
            const movedItem = this[name].splice(evt.oldIndex, 1)[0];
            this[name].splice(evt.newIndex, 0, movedItem);
          },
        });
      });
    },
    handleDialogCloseAnoth() {
      // 任务列表处理
      let commonTaskList = [];
      commonTaskList = this.teamMemberTaskList.map((item, index) => {
        return this.handleTaskData(item);
      });
      // 奖品处理
      let prizeList = [];

      // 惊喜奖品
      if (
        this.commanderForm.commanderPrizeType == 0 &&
        this.tableData.length > 0
      ) {
        prizeList = this.tableData.map((item) => {
          const prize = {
            ...item,
            openTeamType: this.commanderForm.openTeamType,
            groupNums: this.commanderForm.inviteTeamNum,
            prizeObjectType: 0,
          };
          // 提交地址限制：数组转逗号分隔字符串
          if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
            prize.commitAddressLimit = item.commitAddressLimit.join(',');
          }
          return prize;
        });
      } 

      //添加任务
      if (
        this.teamMemberTable.length > 0 &&
        this.teamMemberTable[0].prizeType
      ) {
        let prizeArr = this.teamMemberTable.map((item) => {
          const prize = { ...item, prizeObjectType: 1 };
          // 提交地址限制：数组转逗号分隔字符串
          if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
            prize.commitAddressLimit = item.commitAddressLimit.join(',');
          }
          return prize;
        });
        prizeList.push(...prizeArr);
      }

      // 添加阶梯奖品
      this.prizeSettingListStep.forEach(stepItem => {
        if (stepItem.table && stepItem.table.length > 0 && stepItem.table[0].prizeType) {
          const stepPrizeArr = stepItem.table.map((item) => {
            const prize = {
              ...item,
              openTeamType: stepItem.openTeamType,
              groupNums: stepItem.inviteTeamNum,
              prizeObjectType: 2,
            };
            // 提交地址限制：数组转逗号分隔字符串
            if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
              prize.commitAddressLimit = item.commitAddressLimit.join(',');
            }
            return prize;
          });
          prizeList.push(...stepPrizeArr);
        }
      });

      let ruleDTO = {
        ...this.ruleDTO,
        memberJoinSetting: {
          ...this.memberJoinSetting,
          allowLevel:
            this.memberJoinSetting.allowLevel &&
            this.memberJoinSetting.allowLevel.length
              ? this.memberJoinSetting.allowLevel.join(",")
              : "",
        },
        taskList: commonTaskList,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        ...this.commanderForm,

        punchMode: this.ruleForm.checkInMode, //打卡模式传参
        targetEnrollNumber: this.ruleForm.tagApplyNum, //目标报名人数
        enrollDeadline: this.ruleForm.applyEndTime, //报名截止时间
        unlockRewardCoverUrl: this.ruleForm.screenCoverImage, //解锁奖励图
        enableSurprisePrize: this.ruleForm.isSurprisePrize == 0 ? false : true, //是否开启惊喜奖励
        isForceRemind: this.isForceRemind,
      };
      //个人打卡传参
      if (this.ruleForm.checkInMode == 1) {
        ruleDTO.phoneWallpaperUrls = this.ruleForm.wallpaperList || [];
        ruleDTO.pcWallpaperUrls = this.ruleForm.pcWallpaperList || [];
        ruleDTO.ipadWallpaperUrls = this.ruleForm.ipadWallpaperList || [];
        delete ruleDTO.enableSurprisePrize;
      }
      let obj = {
        ...this.ruleForm,
        subType: 65,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        taskList: commonTaskList,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };
      obj.pointActivityPrizeDTOList = prizeList;
      //后端需要接收空值
      if (
        this.ruleForm.isSurprisePrize == 0 ||
        this.ruleForm.checkInMode == 1
      ) {
        obj.pointActivityPrizeDTOList = [];
      }
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        console.log(
          this.activityData.isStart,
          this.checked,
          this.isDraft,
          "99999"
        );

        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeList.map((item) => {
                    return {
                      ...item,
                      prizeId: item.id,
                    };
                  }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            taskList: commonTaskList,
            endTime: this.ruleForm.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {})
            .finally(() => {
              this.saveLoading = false;
              this.loading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          fansCard(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 任务回显统一回显
    getTaskData(taskList, type) {
      return taskList
        .filter((item) => item.type == type)
        .map((item) => {
          const obj = { ...item };
          const itemObj = this.taskTypeOptions.find(
            (list) => list.value == item.taskType
          );
          if (itemObj && itemObj.taskCondition) {
            obj.taskCondition = itemObj.taskCondition;
          }
          if ([3, 4, 12, 13].includes(item.taskType)) {
            obj.itemListForFilter = item.itemList ? item.itemList : [];
            if ([3, 12, 13].includes(item.taskType)) {
              obj.taskCondition = item.viewCartLimit;
            } else {
              // 加购商品
              obj.taskCondition = item.addCartLimit;
            }
          }
          if (item.taskType == 17) {
            obj.selectGoodsFilterArr = item.itemList ? item.itemList : [];
            obj.itemStartCount = item.itemTotalLimit;
            obj.orderStartPayment = item.amtLimit;
            obj.venderIds =
              item.venderIds
                ? item.venderIds.split(",").map((row) => +row)
                : [this.venderId];
            obj.sellerSkuList = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                skuIds: item.skuIds ? item.skuIds.split(",") : [],
                venderId: this.venderId,
                itemList: [],
              }];
            if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(obj.venderIds.length>0) {
                let index = obj.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  obj.venderIds.unshift(Number(this.venderId))
                  obj.sellerSkuList.unshift({
                    venderId: Number(this.venderId),
                    skuIds: [],
                    itemList: [],
                  })
                }
              }
            }
            obj.mergeOrder = item.mergeOrder|| false;
            obj.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
          }
          return obj;
        });
    },
    // 获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;

        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            this.loading = false;
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              studentSatus,
            } = res.data;
            const {
              commanderPrizeType,
              openTeamType,
              inviteTeamNum,
              taskList,
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              screenCoverImage,
              punchMode,
              phoneWallpaperUrls,
              pcWallpaperUrls,
              ipadWallpaperUrls,
              enableSurprisePrize,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.condFollow = condFollow ? true : false;
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 大屏封面图回显处理
            this.ruleForm.screenCoverImage = ruleDto.unlockRewardCoverUrl || "";
            // 目标报名人数回显处理
            this.ruleForm.tagApplyNum = ruleDto.targetEnrollNumber || "";
            // 报名截止时间回显处理
            this.ruleForm.applyEndTime = ruleDto.enrollDeadline || "";
            // 打卡模式回显处理
            this.ruleForm.checkInMode = Number(punchMode || 0);
            // 惊喜奖品设置回显处理
            this.ruleForm.isSurprisePrize = enableSurprisePrize ? 1 : 0;
            // 统一奖品列表回显处理，确保pointActivityPrizeDTOList存在避免报错
            this.tableData = (pointActivityPrizeDTOList || []).filter(
              (item) => item.prizeObjectType == 0
            ).map(item => {
              // 提交地址限制回显：逗号分隔字符串转数字数组
              if (item.prizeType == 3) {
                if (item.commitAddressLimit) {
                  item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                    ? item.commitAddressLimit.split(',').map(Number)
                    : item.commitAddressLimit;
                } else {
                  item.commitAddressLimit = [0];
                }
              }
              return item;
            });
            // 个人打卡壁纸回显处理
            if (Number(punchMode) === 1) {
              this.ruleForm.wallpaperList = phoneWallpaperUrls || [];
              this.ruleForm.pcWallpaperList = pcWallpaperUrls || [];
              this.ruleForm.ipadWallpaperList = ipadWallpaperUrls || [];
            }
            this.ruleDTO = ruleDto;

            // isForceRemind回显处理
            this.isForceRemind = ruleDto.isForceRemind;

            // placementPosition回显处理
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
            // 是否重点活动回显处理
            this.isKeyActivity = isKeyActivity || 0;

            // 初始化完成任务报告
            this.teamMemberTaskList = this.getTaskData(taskList || [], 0);

            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            this.templateId = templateId;
            this.getPolite();

            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            if (this.activityData.isCopy) {
              // 是否为统一奖品
              if (this.commanderForm.commanderPrizeType == 0) {
                this.tableData = [
                  {
                    assetsId: null, // 资产项id(计划id优惠卷id商品id)
                    prizeType: null,
                    price: null,
                    logo: null,
                    title: "",
                    totalAmount: null,
                  },
                ];
              } else if (this.commanderForm.commanderPrizeType == 1) {
                this.prizeSettingListStep.forEach((item, index) => {
                  item.table = [
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: null,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                    },
                  ];
                });
              }
              this.teamMemberTable = [
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: null,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                },
              ];
              this.ruleForm.ruleDescription = "";
            }
          })
          .catch((res) => {
            this.loading = false;
          });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .ml8 {
    margin-left: 8px;
  }
  .mt12 {
    margin-top: 12px;
  }
  .tips_red {
    color: #ff4d4f;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }
  .prize_box {
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
    &_middle {
      padding-top: 10px;
    }
    &_step {
      margin-top: 16px;
      &_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 10px;
        background-color: #f0f2f7;
        &__delete {
          cursor: pointer;
        }
      }
      &_center {
        background-color: #fff;
        padding: 10px 0px;
      }
    }
  }
  .btn-bg {
    margin-top: 5px;
    width: 80px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .prize-uploader {
    margin-top: 15px;
  }
  .prize-image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
  .prize-image-item {
    width: 120px;
    height: 120px;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    cursor: move;
  }
  .prize-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .image-actions {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-around;
    padding: 4px 0;
  }
  .image-actions .el-button {
    color: #fff;
  }
  .upload-tip {
    color: #909399;
    font-size: 12px;
    margin-top: 8px;
  }
  .upload-tip span {
    margin-right: 16px;
  }

  .flexc1 {
    background-color: #fafafa;
    padding: 30px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .flexc {
    margin-bottom: 10px;
  }
  .phone-img {
    width: 58px;
    height: 125px;
  }
  .ipad-img {
    width: 112px;
    height: 78px;
  }
  .upload-item {
    margin-right: 10px;
    &:hover .delectPosible {
      display: block;
    }
    .delectPosible {
      display: none;
      position: absolute;
      top: 0px;
      // right: 6px;
      background: rgba(0, 0, 0, 0.7);
      cursor: pointer;
      .delectIcom {
        width: 24px;
        height: 24px;
        position: absolute;
        top: -9px;
        right: -8px;
      }
      .delectSort {
        position: absolute;
        top: 50%;
        color: #fff;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .delectPosible {
      display: none;
      position: absolute;
      top: 0px;
      // right: 6px;
      background: rgba(0, 0, 0, 0.7);
      cursor: pointer;
      .delectIcom {
        width: 24px;
        height: 24px;
        position: absolute;
        top: -9px;
        right: -8px;
      }
      .delectSort {
        position: absolute;
        top: 50%;
        color: #fff;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .computer-img {
      width: 118px;
      height: 66px;
    }
  }
}
</style>
